import { Grid, useMediaQuery, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'

import {
  Filter,
  MainContainer,
  ImpactsLibraryNavButton,
  ImpactPeriodsGrid,
  ImpactPeriodsTable,
  HelperWrapper,
} from 'src/components'
import { initialImpactPeriodsFilter, useFilter, useImpactPeriods } from 'src/hooks'

import { joinAbsRoute } from 'src/common/utils'
import { ROUTES } from 'src/constants'

const ImpactPeriodsComponent = () => {
  const [t] = useTranslation()
  const [filter, setFilter] = useFilter({ initialState: initialImpactPeriodsFilter })
  const theme = useTheme()

  const { data: items } = useImpactPeriods(filter)

  const isTablet = useMediaQuery(theme.breakpoints.down('tablet'))

  return (
    <Grid container>
      <Filter
        sortOptions={[]}
        searchFieldText={t('impact-periods-search-input.v')}
        filter={filter}
        setFilter={setFilter}
        selectionOptions={[]}
        initialState={initialImpactPeriodsFilter}
      />
      {!isTablet && <ImpactsLibraryNavButton />}
      {isTablet ? (
        <ImpactPeriodsGrid filter={filter} items={items} />
      ) : (
        <ImpactPeriodsTable filter={filter} items={items} />
      )}
    </Grid>
  )
}

const ImpactPeriodsScreen = () => {
  return (
    <MainContainer
      headerTitle={<HelperWrapper t="impact-periods-header-title" />}
      navigateBack
      navigateBackRoute={joinAbsRoute(ROUTES.IMPACTS_LIBRARY)}
    >
      <ImpactPeriodsComponent />
    </MainContainer>
  )
}

export default ImpactPeriodsScreen
